import React, { useState } from 'react'
import Select from 'react-select'
import { Drawer } from 'antd'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'

import { clearOrder, modifyOrderItem, removeOrderItem } from '../../store/actions'
import { normalize, useToggle, usePet } from '../../modules'

import PayModal from '../modals/paymodal'

export const OrderItem = ({ index, item, order }) => {
    const [onComplete, setOnComplete] = useState()
    const [quantity, setQty] = useState(0)

    const { closeSnackbar } = useSnackbar()

    const dispatch = useDispatch()

    const [, canDispense] = usePet('canDispense', {
        id: item.variant._id,
        quantity,
        targets: localStorage
    }, {
        notify: true, callback: ({ data }, notif, ops) => {
            closeSnackbar()
            if (data.status) {
                onComplete?.callback()
            } else {
                console.log(data)
                if (item.variant.type === 'Sale Item') {
                    notif(`${data.store} only has ${data.qty} of ${data.item} left`, ops('warning'))
                } else {
                    notif(`${data.store} only has ${data.ingredients[Object.keys(data.ingredients)[0]]} of ${Object.keys(data.ingredients)[0]} left`, ops('warning'))
                }
            }
        }, manual: true, load: { msg: 'Checking inventory...' }
    })
    
    const okToDispense = (quantity, callback) => {
        setQty(quantity)
        setOnComplete({ callback })
        canDispense()
    }

    const modifyQty = val => {
        if (val > 0) {
            okToDispense(val, () => dispatch(modifyOrderItem(index, val)))
        } else if (val === 0) {
            dispatch(removeOrderItem(index))
        }
    }

    return (
        <tr>
            <td className="p-2 pl-4 h-5">{index + 1}</td>
            <td className="p-2 pl-4 h-5 flex">{item?.variant?.name}</td>
            <td className="p-2 pl-4 h-5">Ksh. {item.price}</td>
            <td className="p-2 text-left flex justify-center items-center">
                <button onClick={() => modifyQty(item.qty - 1)} type="button" className="px-4 py-3 rounded-md outline-none focus:ring-4 shadow-lg">-</button>
                <div className="p-3">{item.qty}</div>
                <button onClick={() => modifyQty(item.qty + 1)} type="button" className="px-4 py-3 rounded-md outline-none focus:ring-4 shadow-lg">+</button>
            </td>
            <td className="p-2 pl-4 h-5">{index >= 0 ? `Ksh. ${item.qty * item.price}` : '_'}</td>
        </tr>
    )
}

const Accordion = ({ title, children, open, onClick }) => {
    return (
        <button onClick={() => onClick(title)} className="w-full group border border-gray-50 focus:outline-none">
            <div className="flex items-center justify-between h-12 px-3 font-semibold hover:bg-gray-100">
                <span className="truncate">{title}</span>
                <svg className="h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
            </div>
            <div className={`${open === title ? 'max-h-auto' : 'max-h-0'} pl-3 pr-3 text-left overflow-hidden duration-300 group-focus:max-h-40`}>
                {children}
            </div>
        </button>
    )
}

const Order = ({ bill = null, visible, tables = [], toggle, onPerform = () => null }) => {
    const [open, setOpen] = useState('Items')
    const [name, setName] = useState()
    const [discount, setDiscount] = useState(0)
    const [phone, setPhone] = useState()
    const [details, setDetails] = useState()
    const [waiters, setWaiters] = useState([])
    const [waiter, setWaiter] = useState()
    const [table, setTable] = useState({ label: 'Over the Counter', value: 'Over the Counter'})
    const [received, setReceived] = useState()
    
    const history = useHistory()

    const [payModal, togglePayModal] = useToggle()
    const [payAfter, togglePayAfter] = useToggle()

    usePet('allUsers', { page: 1, limit: 100 }, { notify: true, callback: async ({ data }) =>
        setWaiters(data.users.map(u => ({ label: u.name, value: u._id }))) })

    const { order } = useSelector(state => state.order)
    const dispatch = useDispatch()

    const backToOrders = () => history.push('/app/bills')

    const clear = () => {
        dispatch(clearOrder())
        toggle()
    }

    const onComplete = ({ data }, notif, ops) => {
        notif(bill? 'Items have been added to bill' : 'Bill has been opened', ops('success'))
        onPerform()

        if (payAfter) {
            setReceived(data)
            togglePayModal()
        } else {
            backToOrders()
        }
    }

    const modify = e => {
        switch (e.target.name) {
            case 'name':
                setName(e.target.value)
                break
                
            case 'phone':
                setPhone(e.target.value)
                break

            case 'details':
                setDetails(e.target.value)
                break

            case 'discount':
                setDiscount(e.target.value)
                break
                
            case 'waiter':
                setWaiter(e.target.value)
                break

            default:
                break
        }
    }   

    const [{ loading }, execute] = usePet('billItems', {
        items: order.map(({ variant, qty, price }) => ({
            item: variant._id,
            quantity: qty,
            price,
            destination: variant.defaultDestination,
            taxRate: variant.noTax ? 0 : 18
        })),
        waiter: waiter?.value,
        table: table?.value,
        name,
        phone,
        details,
        targets: localStorage
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Opening bill...' } })

    const [{ loading: addLoading }, addItemsToBill] = usePet('billItems', {
        bill,
        items: order.map(({ variant, qty, price }) => ({
            item: variant._id,
            quantity: qty,
            price,
            destination: variant.defaultDestination,
            taxRate: variant.noTax ? 0 : 18
        })),
        targets: localStorage
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Adding items to bill...' } })

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={toggle}
            footer={
                <div className="w-full text-right">
                    <button onClick={ () => {
                        togglePayAfter()
                        if (bill) {
                            addItemsToBill()
                            return
                        }

                        execute()
                    } } className="text-white hisani-btn-orange mr-3 font-medium rounded-lg text-sm px-5 py-2.5 text-center">{ bill ? 'Add Items' : 'Open' } & Receive Payment</button>
                    <button disabled={ loading || addLoading } onClick={ bill ? addItemsToBill : execute } className="text-white hisani-btn-green  mr-3 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">{ bill ? 'Add Items' : 'Open Bill' }</button>
                    <button onClick={ clear } className="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Clear Items</button>
                </div>
            }
            width={640}>
            <PayModal
                order={ received }
                onPerform={ backToOrders }
                toggle={ togglePayModal  }
                visible={ payModal } />
            <p className="font-extrabold text-3xl mb-0">New Bill</p>
            <div className="flex flex-col w-full mt-10">
                <Accordion
                    open={open}
                    title="Items"
                    onClick={setOpen}>
                    {
                        order.length > 0 ?
                            <>
                                <table className="table-auto w-full mt-2 mb-4">
                                    {/* Table header */}
                                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                        <tr>
                                            <th className="p-2 pl-4 text-left">
                                                <div className="font-semibold">No.</div>
                                            </th>
                                            <th className="p-2 pl-4 text-left">
                                                <div className="font-semibold">Item</div>
                                            </th>
                                            <th className="p-2 pl-4 text-left">
                                                <div className="font-semibold">Unit Price</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">Quantity</div>
                                            </th>
                                            <th className="p-2 pl-4 text-left">
                                                <div className="font-semibold">Price</div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            order.map((item, i) =>
                                                <OrderItem index={i} item={item} />)
                                        }
                                    </tbody>
                                </table>
                            </>
                            :
                            <div className="flex justify-center items-center h-10">
                                <h2>No items have been selected</h2>
                            </div>
                    }
                </Accordion>
                <Accordion onClick={order.length > 0 ? setOpen : () => null} open={order.length > 0 && open} title="Additional Information">
                    {
                        !bill &&
                        <>
                            <p className="text-sm font-bold">Internal Info</p>
                            <div className="w-full flex p-3 pb-0 mb-3">
                                <div className="w-1/2 flex flex-col flex-wrap mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                        Waiter
                                    </label>
                                    <Select
                                        value={waiter}
                                        onChange={setWaiter}
                                        className="text-black"
                                        options={ waiters }
                                        placeholder="Select Waiter" />
                                </div>
                                <div className="w-1/2 flex flex-col flex-wrap ml-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                        Table
                                    </label>
                                    <Select
                                        value={table}
                                        onChange={setTable}
                                        className="text-black"
                                        options={
                                            tables.map(tbl => ({ label: tbl.name, value: tbl.name }))
                                        }
                                        placeholder="Select Table" />
                                </div>
                            </div>
                        </>
                    }
                    <p className="text-sm font-bold">Customer Info</p>
                    <div className="w-full flex p-3 pb-0">
                        <div className="w-1/2 flex flex-wrap mr-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Customer Name
                            </label>
                            <input
                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                id="grid-name"
                                name="name"
                                onChange={ modify }
                                value={ name }
                                type="text"
                                placeholder="Samuel Okoth" />
                        </div>
                        <div className="w-1/2 flex flex-wrap ml-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Customer Phone
                            </label>
                            <input
                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                id="grid-phone"
                                name="phone"
                                onChange={ modify }
                                value={ phone }
                                type="text"
                                placeholder="07XXXXXXXX" />
                        </div>
                    </div>
                    <div className="w-full flex p-3 pt-0">
                        <div className="w-full flex flex-wrap mr-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Customer Details
                            </label>
                            <textarea
                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                id="grid-details"
                                type="text"
                                name="details"
                                onChange={ modify }
                                value={ details }
                                rows="5"
                                placeholder="Take away order, deliver to ..." />
                        </div>
                    </div>
                </Accordion>
                <div className="flex flex-col items-end mb-3 p-3">
                    <p className="font-semibold text-lg underline mb-2">Summary</p>
                    <p>Before Tax: Ksh. { normalize(order.reduce((total, itm) => total + (itm.price * itm.qty * (itm.variant.noTax ? 1 : (1 - 0.18))), 0)) }</p>
                    <p>Tax (18%): Ksh. { normalize(order.reduce((total, itm) => total + (itm.price * itm.qty * (itm.variant.noTax ? 0 : 0.18)), 0)) }</p>
                    <p>Discount: Ksh. { normalize(discount) }</p>
                    <p>Total: Ksh. { normalize(order.reduce((total, itm) => total + (itm.price * itm.qty), 0) - discount) }</p>
                </div>
            </div>
        </Drawer>
    )
}

export default Order